import { render, staticRenderFns } from "./DevelopmentSummary.vue?vue&type=template&id=2bb54f88"
import script from "./DevelopmentSummary.vue?vue&type=script&lang=js"
export * from "./DevelopmentSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports